export function getToken() {
  try {
    const vuex_access_token = localStorage.getItem("token");
    return vuex_access_token;
  } catch (error) {
    return "";
  }
}
